import { createFileRoute, Outlet, useNavigate, useRouterState } from '@tanstack/react-router';
import { Stack, Tabs } from '@mantine/core';
import { PageHeader } from '@/shared/components/PageHeader';

export const Route = createFileRoute('/_app/timesheet')({ component: TimesheetLayout });

const TABS = [
  { value: 'entries', label: 'Ore', path: '/timesheet' },
  { value: 'by-project', label: 'Ore per commessa', path: '/timesheet/by-project' },
  { value: 'approval', label: 'Approvazione', path: '/timesheet/approval' },
  { value: 'reasons', label: 'Causali', path: '/timesheet/reasons' },
] as const;

function TimesheetLayout() {
  const navigate = useNavigate();
  const path = useRouterState({ select: (s) => s.location.pathname });
  const active =
    TABS.find((t) => (t.path === '/timesheet' ? path === '/timesheet' : path.startsWith(t.path)))?.value ?? 'entries';
  return (
    <Stack>
      <PageHeader title="Timesheet" description="Rapportino ore, ripartizione per commessa e approvazione." />
      <Tabs value={active} onChange={(v) => {
        const tab = TABS.find((t) => t.value === v);
        if (tab) void navigate({ to: tab.path });
      }}>
        <Tabs.List>
          {TABS.map((t) => (
            <Tabs.Tab key={t.value} value={t.value}>{t.label}</Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
      <Outlet />
    </Stack>
  );
}
